/* tslint:disable */

/* eslint-disable */

/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists, mapValues } from "../runtime";

/**
 *
 * @export
 * @interface Group
 */
export interface Group {
  /**
   *
   * @type {string}
   * @memberof Group
   */
  id: string;
  /**
   *
   * @type {Date}
   * @memberof Group
   */
  createdAt: Date;
  /**
   *
   * @type {Date}
   * @memberof Group
   */
  updatedAt: Date | null;
  /**
   *
   * @type {Date}
   * @memberof Group
   */
  deletedAt: Date | null;
  /**
   *
   * @type {string}
   * @memberof Group
   */
  createdBy: string | null;
  /**
   *
   * @type {string}
   * @memberof Group
   */
  updatedBy: string | null;
  /**
   *
   * @type {string}
   * @memberof Group
   */
  deletedBy: string | null;
  /**
   *
   * @type {string}
   * @memberof Group
   */
  name: string;
}

export function GroupFromJSON(json: any): Group {
  return GroupFromJSONTyped(json, false);
}

export function GroupFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Group {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    createdAt: new Date(json["created_at"]),
    updatedAt:
      json["updated_at"] === null ? null : new Date(json["updated_at"]),
    deletedAt:
      json["deleted_at"] === null ? null : new Date(json["deleted_at"]),
    createdBy: json["created_by"],
    updatedBy: json["updated_by"],
    deletedBy: json["deleted_by"],
    name: json["name"],
  };
}

export function GroupToJSON(value?: Group | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    created_at: value.createdAt.toISOString(),
    updated_at: value.updatedAt === null ? null : value.updatedAt.toISOString(),
    deleted_at: value.deletedAt === null ? null : value.deletedAt.toISOString(),
    created_by: value.createdBy,
    updated_by: value.updatedBy,
    deleted_by: value.deletedBy,
    name: value.name,
  };
}
